export default __webpack_public_path__ + "img/sun-icon.svg";